/**
 * The client's reader of a frame rate the server sent in a payload (the
 * match summary, playlist video-meta, match-lab-info, ...).
 *
 * A game with no recorded rate is sent `fps: null` (#1075 removed the
 * model's default of 25). The client must not invent one: 25 puts every
 * time on a 30 fps game 20% late, 30 puts a 25 fps game's about 17%
 * early. A surface that reads null shows NO_FRAME_RATE_NOTE instead of
 * placing anything. frameRate.guard.test.ts fails on a new `fps ?? <n>`,
 * `fps || <n>`, `fps = <n>` or `fps: <n>` in non-test source under src.
 */

/** The game's frame rate as the server sent it, or null when it sent
 *  none (or anything that is not a positive finite number). */
export function servedFps(fps: unknown): number | null {
  return typeof fps === 'number' && Number.isFinite(fps) && fps > 0 ? fps : null
}

/** What a surface says in place of times it cannot place. */
export const NO_FRAME_RATE_NOTE = 'No frame rate recorded for this game, so moments cannot be placed in time.'
